import { usuarioApi } from 'app/services/api/usuarioApi';
import React, { useEffect, useRef, useState } from 'react';

const TracksaleWidget = () => {
  const divRef = useRef(null);
  const isFirstRender = useRef(true);
  const [data, setData] = useState('');

  const empresaContextoArmazenada = localStorage.getItem('EC');
  useEffect(() => {
    async function carregarTracksale() {
      const response = await usuarioApi.buscarUsuarioClienteLogado();

      if (!response?.data?.trial) {
        setData(
          `<script>(function(f,b,g){console.log("Carregando widget tracksale...");var a={key:"${process.env.REACT_APP_WIDGET_TRACKSALE_KEY}",campaign:"${process.env.REACT_APP_WIDGET_TRACKSALE_CAMPAIGN}",name:"${response?.data?.nome}",email:"${response?.data?.email}",salute:"${response?.data?.nome}, tudo bem?",thanks:"Obrigado, ${response?.data?.nome}!"};var e;var c=f.getElementsByTagName(b)[0];if(f.getElementById(g)){return}e=f.createElement(b);e.id=g;e.src="https://cdn.tracksale.co/tracksale-js/tracksale.js";e.type="text/javascript";e.async=true;e.onload=e.onreadystatechange=function(){var h=this.readyState;if(h&&h!="complete"&&h!="loaded"){return}try{var d=new Tracksale();d.init(a)}catch(i){}};c.parentNode.insertBefore(e,c)}(document,"script","tracksale-js"));</script>`
        );
      }
    }
    if (
      localStorage.getItem('EC') &&
      process.env.REACT_APP_WIDGET_TRACKSALE_KEY &&
      process.env.REACT_APP_WIDGET_TRACKSALE_CAMPAIGN &&
      process.env.REACT_APP_TRACKSALE_PERIODO_INICIO &&
      process.env.REACT_APP_TRACKSALE_PERIODO_FIM
    ) {
      const dataAtual = new Date();
      const dataInicio = new Date(process.env.REACT_APP_TRACKSALE_PERIODO_INICIO);
      const dataFim = new Date(process.env.REACT_APP_TRACKSALE_PERIODO_FIM);

      if (dataAtual > dataInicio && dataAtual < dataFim) {
        carregarTracksale();
      }
    }
  }, [empresaContextoArmazenada]);

  useEffect(() => {
    if (data && divRef.current) {
      if (!isFirstRender.current) {
        return;
      }
      isFirstRender.current = false;

      const slotHtml = document.createRange().createContextualFragment(data); // Create a 'tiny' document and parse the html string
      divRef.current.innerHTML = ''; // Clear the container
      divRef.current.appendChild(slotHtml); // Append the new content
    }
  }, [data, divRef]);

  return <div ref={divRef} />;
};

export default TracksaleWidget;
